import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';

import { ContactHfsDto, InviteCustomerDto } from './intermediary.dto';

export class IntermediaryApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/intermediaries');
  }

  public async contactHfs(contactHfsDto: ContactHfsDto) {
    return this.instance.post('/contact-hfs', contactHfsDto).then((response: AxiosResponse<any>) => response.data);
  }

  public async inviteCustomer(inviteCustomerDto: InviteCustomerDto) {
    return this.instance
      .post('/invite-customer', inviteCustomerDto)
      .then((response: AxiosResponse<any>) => response.data);
  }

  public async scheduleMeeting() {
    return this.instance.post('/schedule-meeting').then((response: AxiosResponse<void>) => response.data);
  }
}
